export default __webpack_public_path__ + "static/media/full-gift-party.453481d4.svg";